import { Button } from "@mui/material";
import "./popMenu.scss";
const IntroPop = ({ setInvestorPop }: any) => {
  return (
    <>
      <div className="business-summary-popUp">
        <div className="business-summary-main-dev">
          <samp>
            <img src="https://public.ticca.com/images/svg/Intro.svg" alt="Intro" />
          </samp>
          <p>
            Register to read our <samp>Intro</samp>
          </p>
          <Button
            onClick={() => {
              let Api_URL: any = "";
              const env = process.env.REACT_APP_STAGE_ENV;
              switch (env) {
                case "dev":
                  Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                  break;
                case "stage":
                  Api_URL = process.env.REACT_APP_TICCA_STAGE_SINUP;
                  break;
                case "prod":
                  Api_URL = process.env.REACT_APP_TICCA_PRO_SINUP;
                  break;
                default:
                  Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                  break;
              }

              window.location.href = Api_URL;
            }}
            className="btn-ticca"
            type="submit"
          >
            Register
          </Button>
          <samp
            onClick={() => {
              setInvestorPop(false);
            }}
            className="investor-close"
          >
           <img src="https://public.ticca.com/images/svg/InvestorMenuCloseArrow.svg" alt="close-icon" />
          </samp>
        </div>
      </div>
    </>
  );
};

export default IntroPop;


